import React from 'react';
import PropTypes from 'prop-types';
import { SiteFooter } from '@homeaway/react-site-footer/lib/transpiled/components/SiteFooter';
import EdapModuleView from '../EdapModuleView';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';

const Footer = ({ data, isMobile, site }) => (
  <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
    <SiteFooter {...{ data, isMobile, site }} />
  </EdapModuleView>
);

Footer.propTypes = {
  data: PropTypes.shape({
    siteInfo: PropTypes.object,
    smsWidget: PropTypes.object,
    emailWidget: PropTypes.object,
    login: PropTypes.object,
    family: PropTypes.object,
    legal: PropTypes.object,
    social: PropTypes.array
  }).isRequired,
  isMobile: PropTypes.bool.isRequired,
  site: PropTypes.string.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./src/universal/components/Footer/Footer.js